import { createFileRoute, Outlet } from '@tanstack/react-router';

// Passthrough layout — (pages)/index.tsx renders at /certifications/
export const Route = createFileRoute('/(client)/certifications/(pages)')({
  component: () => <Outlet />,
});
